/**
 * format.js — money / number formatting for Indian markets.
 * Everything returns strings; callers control color/sign semantics.
 */

const NF0 = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 })
const NF2 = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/** ₹ with Indian grouping, no decimals by default. */
export function inr(value, { decimals = 0 } = {}) {
  if (value == null || Number.isNaN(Number(value))) return '—'
  const n = Number(value)
  return `₹${(decimals === 2 ? NF2 : NF0).format(n)}`
}

/** Compact ₹ for hero figures: ₹1.24Cr · ₹63.0L · ₹8,400. */
export function inrCompact(value) {
  if (value == null || Number.isNaN(Number(value))) return '—'
  const n = Number(value)
  const abs = Math.abs(n)
  const sign = n < 0 ? '-' : ''
  if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(2)}Cr`
  if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(2)}L`
  return `${sign}₹${NF0.format(abs)}`
}

/** Signed ₹ (for P&L): +₹1,240 / -₹980. */
export function inrSigned(value, { compact = false } = {}) {
  if (value == null || Number.isNaN(Number(value))) return '—'
  const n = Number(value)
  const body = compact ? inrCompact(Math.abs(n)) : inr(Math.abs(n))
  return `${n >= 0 ? '+' : '-'}${body}`
}

/** Percentage with sign: +2.41% / -0.83%. */
export function pct(value, { decimals = 2, sign = true } = {}) {
  if (value == null || Number.isNaN(Number(value))) return '—'
  const n = Number(value)
  return `${sign && n >= 0 ? '+' : n < 0 ? '-' : ''}${Math.abs(n).toFixed(decimals)}%`
}

/** Plain grouped number. */
export function num(value, { decimals = 0 } = {}) {
  if (value == null || Number.isNaN(Number(value))) return '—'
  return (decimals === 2 ? NF2 : NF0).format(Number(value))
}

export const isUp = (v) => Number(v) >= 0

/** Strip inline HTML tags + decode common entities — for excerpts, word counts, search. */
export function stripHtml(s) {
  return String(s || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
}
